import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, FormControl, ReactiveFormsModule } from '@angular/forms';
import { ClientComponent } from './client/client.component';
import { InsertClientComponent } from './insert-client/insert-client.component';
import { ModalsComponent } from './modals/modals.component';
import { MethodInsertComponent } from './method-insert/method-insert.component';
import { MachineInsertComponent } from './machine-insert/machine-insert.component';
import { IndicatorInsertComponent } from './indicator-insert/indicator-insert.component';
import { ProductInsertComponent } from './product-insert/product-insert.component';
import { SubjectComponent } from './subject/subject.component';
import { SubjectInsertComponent } from './subject-insert/subject-insert.component';
import { SubjectAccountModalComponent } from './subject-account-modal/subject-account-modal.component';
import { GroupComponent } from './group/group.component';
import { GroupInsertComponent } from './group-insert/group-insert.component';
import { EmployeeComponent } from './employee/employee.component';
import { EmployeeInsertComponent } from './employee-insert/employee-insert.component';
import { RequestComponent, CopyRequest } from './request/request.component';
import { RequestInsertComponent, ClientModal, IndicatorModal } from './request-insert/request-insert.component';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent, LoginFailComponent } from './login/login.component';
import { SettingsComponent } from './settings/settings.component';
import { IpsComponent } from './ips/ips.component';
import { PathLocationStrategy, LocationStrategy } from '@angular/common';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatInputModule,
  MatCardModule,
  MatDialogModule,
  MatDialogRef,
  MatRadioModule,
  MatSelectModule,
  MatTableDataSource,
  MatTableModule,
  MatSortModule,
  MatPaginatorModule,
  MatSnackBarModule,
  MatMenuModule,
  MatIconModule,
  MatTabsModule,
  MatChipsModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatAutocompleteModule
} from '@angular/material';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SystemDataComponent, Service } from './system-data/system-data.component';
import { PackageInsertComponent } from './package-insert/package-insert.component';
import { TechniciansComponent, TechnicianInsert } from './technicians/technicians.component';
import { NgArrayPipesModule } from 'angular-pipes';
import { TicketSystemComponent, Identification, Results, ResultConfirm } from './ticket-system/ticket-system.component';
import { IdentificationInputComponent } from './identification-input/identification-input.component';
import { DocumentComponent } from './document/document.component';
import { OnlyNumber } from './directives/only-number.directive';
import { DocumentInsertComponent, EditRow } from './document-insert/document-insert.component';
import { PriceDirective } from './directives/price.directive';
import { AcceptProtocolComponent, ProtocolRes, AcceptModal, DeclineModal } from './accept-protocol/accept-protocol.component';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { RouterModule, PreloadAllModules, ROUTES } from '@angular/router';
import { MomentDateModule} from '@angular/material-moment-adapter';
import { ArchiveRequestComponent } from './archive-request/archive-request.component';
import { ArchivedRequestsComponent } from './archived-requests/archived-requests.component';




@NgModule({
  declarations: [
    AppComponent,
    ClientComponent,
    InsertClientComponent,
    ModalsComponent,
    MethodInsertComponent,
    MachineInsertComponent,
    IndicatorInsertComponent,
    ProductInsertComponent,
    SubjectComponent,
    SubjectInsertComponent,
    SubjectAccountModalComponent,
    GroupComponent,
    GroupInsertComponent,
    EmployeeComponent,
    EmployeeInsertComponent,
    RequestComponent,
    RequestInsertComponent,
    DashboardComponent,
    LoginComponent,
    SettingsComponent,
    IpsComponent,
    ClientModal,
    IndicatorModal,
    HeaderComponent,
    FooterComponent,
    SystemDataComponent,
    PackageInsertComponent,
    TechniciansComponent,
    TechnicianInsert,
    LoginFailComponent,
    TicketSystemComponent,
    Identification,
    Results,
    Service,
    ProtocolRes,
    AcceptModal,
    DeclineModal,
    IdentificationInputComponent,
    DocumentComponent,
    ResultConfirm,
    CopyRequest,
    OnlyNumber,
    DocumentInsertComponent,
    PriceDirective,
    AcceptProtocolComponent,
    ArchiveRequestComponent,
    ArchivedRequestsComponent,
    EditRow
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbDatepickerModule,
    FormsModule,
    NguiAutoCompleteModule,
    Ng2SmartTableModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatCardModule,
    MatDialogModule,
    MatRadioModule,
    MatSelectModule,
    MatSortModule,
    MatSnackBarModule,
    MatTableModule,
    MatPaginatorModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MomentDateModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatTabsModule,
    NgArrayPipesModule,
    ReactiveFormsModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgbModule.forRoot(),
    NgxLoadingModule
    
  ],
  entryComponents: [ModalsComponent,IndicatorInsertComponent,MethodInsertComponent,SubjectAccountModalComponent,MachineInsertComponent,ProductInsertComponent,SubjectInsertComponent, ClientComponent,ClientModal,IndicatorModal,PackageInsertComponent,TechnicianInsert,LoginFailComponent,Identification,Results,Service,ProtocolRes,AcceptModal,DeclineModal,ResultConfirm,CopyRequest,EditRow],
  providers: [{ provide: LocationStrategy, useClass: PathLocationStrategy }],
  bootstrap: [AppComponent]
})
export class AppModule { }
